import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=2aa7924a&scoped=true&lang=pug&"
import script from "./landing.vue?vue&type=script&lang=js&"
export * from "./landing.vue?vue&type=script&lang=js&"
import style0 from "./landing.vue?vue&type=style&index=0&id=2aa7924a&prod&lang=scss&"
import style1 from "./landing.vue?vue&type=style&index=1&id=2aa7924a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa7924a",
  null
  
)

export default component.exports